import {ErrorBoundary, ErrorBoundaryProps} from "react-error-boundary";
import {ComponentType} from "react";

/**
 * Higher-order component which wraps a component with an ErrorBoundary.
 * @param Component the component to wrap
 * @param boundaryProps props to pass to the ErrorBoundary
 */
const wrapWithErrorBoundary = <Props extends {}>(
	Component: ComponentType<Props>,
	boundaryProps: ErrorBoundaryProps = {fallback: null}
): ComponentType<Props> => {
	const WrappedComponent = (props: Props) => (
		<ErrorBoundary {...boundaryProps}>
			<Component {...props} />
		</ErrorBoundary>
	);
	return WrappedComponent;
};

export default wrapWithErrorBoundary;
